export default __webpack_public_path__ + "static/media/infocard1.a026cf22.png";